export default {
      id: "bucket-usage",
      viewBox: "0 0 19 24",
      url: __webpack_public_path__ + "img/icons.479460d5.svg#bucket",
      toString: function () {
        return this.url;
      }
    }